// Back In Stock app integration — listens for theme:variant:changed (dispatched by variant-select.js
// after every variant update) and shows/hides the #BIS_trigger button based on availability,
// setting data-variant-id so the app knows which variant to notify for.
(function() {
  function syncBIS(variant) {
    const bisTrigger = document.getElementById('BIS_trigger');
    if (!bisTrigger) return;

    if (variant && variant.available) {
      bisTrigger.style.display = 'none';
    } else {
      bisTrigger.style.display = '';
      if (variant) bisTrigger.setAttribute('data-variant-id', variant.id);
    }
  }

  document.addEventListener('theme:variant:changed', (e) => {
    syncBIS(e.detail.variant);
  });
})();
